import { CrmPageNotificationsProvider } from '../contexts/CrmPageNotificationsContext';
import { PortalProvider } from '../contexts/PortalContext';
import type { PortalKind } from '../lib/portal';
import { RequireAuth } from './RequireAuth';
import { RequirePortalChoice } from './RequirePortalChoice';
import { DesignAppShell } from './layout/DesignAppShell';

export function DesignPortalApp({ kind }: { kind: PortalKind }) {
  return (
    <PortalProvider kind={kind}>
      <RequireAuth>
        <RequirePortalChoice>
          <CrmPageNotificationsProvider>
            <DesignAppShell />
          </CrmPageNotificationsProvider>
        </RequirePortalChoice>
      </RequireAuth>
    </PortalProvider>
  );
}
